export default function BaseUIHandler() {
  const handlePolicyRejection = (title, text, buttonText, failureData, actionContext, clientContext) => {
    return Promise.resolve(com.ts.mobile.sdk.ConfirmationInput.create(-1));
  };
  const processJsonData = (jsonData, actionContext, clientContext) => {
    window.authInvokeResult = jsonData;
    return Promise.resolve(com.ts.mobile.sdk.JsonDataProcessingResult.create(true));
  };
  const startActivityIndicator = (actionContext, clientContext) => {};
  const endActivityIndicator = (actionContext, clientContext) => {};
  const controlFlowStarting = () => {};
  const controlFlowEnded = () => {};
  const controlFlowActionStarting = () => {};
  const controlFlowActionEnded = () => {};
  const createFormSession = (formId, payload) => {
    switch (window.path) {
      case "TrustScoreSdkComponent":
        return new Window.TrustScoreFormSession(formId, payload);
        break;
      case "InstantAuthSdkComponent":
        return new Window.InstantAuthFormSession(formId, payload);
        break;
      case "OtpSdkComponent":
        return new Window.OtpFormSession(formId, payload, Window.CustomThemeObject);
        break;
      case "TrustStampSdkComponent":
        return new Window.ConsentFormSession(formId, payload);
        break;
      case "IovationBindSdkComponent":
        return new Window.DeviceBindFormSession(formId, payload);
        break;
      case "InstantlinkConsentSdkComponent":
        return new Window.InstantlinkConsentFormSession(formId, payload);
        break;
    }
  };
  const createTicketWaitSession = () => {
    switch (window.path) {
      case "TrustStampSdkComponent":
        return new Window.TrustStampTicketWaitSession(Window.customThemeObject);
        break;
      case "InstantlinkSdkComponent":
        return new Window.InstantLinkTicketWaitSession();
        break;
      case "InstantAuthSdkComponent":
        return new Window.InstantAuthTicketWaitSession();
    }
  };
  const controlOptionForCancellationRequestInSession = function (validOptions, session) {
    return Promise.resolve(com.ts.mobile.sdk.ControlRequest.create(com.ts.mobile.sdk.ControlRequestType.AbortAuthentication));
  };
  const handlePolicyRedirect = () => {
    return Promise.resolve(com.ts.mobile.sdk.RedirectInput.create(com.ts.mobile.sdk.RedirectResponseType.RedirectToPolicy));
  };
  return {
    handlePolicyRejection: handlePolicyRejection,
    processJsonData: processJsonData,
    createFormSession: createFormSession,
    startActivityIndicator: startActivityIndicator,
    endActivityIndicator: endActivityIndicator,
    controlFlowStarting: controlFlowStarting,
    controlFlowEnded: controlFlowEnded,
    controlFlowActionStarting: controlFlowActionStarting,
    controlFlowActionEnded: controlFlowActionEnded,
    handlePolicyRedirect: handlePolicyRedirect,
    controlOptionForCancellationRequestInSession: controlOptionForCancellationRequestInSession,
    createTicketWaitSession: createTicketWaitSession
  };
}